import React from 'react';
import {
  HeadingText,
  Modal,
  StackLayout,
  Image,
  Button,
  HeadingBar,
  StackItem,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { ImpersonationType } from '@leagueplatform/auth-utils';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { CORE_ASSET_KEYS } from '../../assets.types';

type PermissionsErrorModalProps = {
  onModalOpenChange: (isOpen: boolean) => void;
  isActionError: boolean;
  impersonationType: ImpersonationType;
};

export const PermissionsErrorModal = ({
  onModalOpenChange,
  isActionError,
  impersonationType,
}: PermissionsErrorModalProps) => {
  const { formatMessage } = useIntl();

  const errorModalImage = useStaticAsset(
    CORE_ASSET_KEYS.WEB_COMMON_ERROR_STATE_IMAGE,
  ) as string;

  const message = isActionError
    ? formatMessage(
        { id: 'CSE_RESTRICTED_ACTION_MESSAGE' },
        { type: impersonationType },
      )
    : formatMessage(
        { id: 'CSE_RESTRICTED_VIEW_MESSAGE' },
        { type: impersonationType },
      );

  return (
    <StackLayout>
      <Modal.Root open onOpenChange={onModalOpenChange}>
        <Modal.Content showCloseButton={false} padding="$none">
          <HeadingBar
            trailingAction={
              <Modal.Close>
                <Button
                  priority="tertiary"
                  quiet
                  icon="tinyClose"
                  hideLabel
                  size="small"
                >
                  {formatMessage({ id: 'CLOSE' })}
                </Button>
              </Modal.Close>
            }
            title={
              <Modal.Title>
                <HeadingText
                  size="sm"
                  level="2"
                  css={{ typography: '$subtitleOne' }}
                >
                  {formatMessage({ id: 'CSE_RESTRICTED_ACTION' })}
                </HeadingText>
              </Modal.Title>
            }
          />
          <StackLayout
            horizontalAlignment="center"
            css={{ padding: '$oneAndHalf' }}
          >
            <Image
              width={120}
              height={120}
              css={{ paddingBottom: '$one' }}
              src={errorModalImage}
            />
            <Modal.Description>
              <ParagraphText
                css={{ typography: '$bodyOne', textAlign: 'center' }}
              >
                {message}
              </ParagraphText>
            </Modal.Description>
          </StackLayout>
          <StackItem css={{ padding: '$none $oneAndHalf $one' }}>
            <Modal.Close>
              <Button width="fillContainer" priority="primary" size="large">
                {formatMessage({ id: 'GOT_IT' })}
              </Button>
            </Modal.Close>
          </StackItem>
        </Modal.Content>
      </Modal.Root>
    </StackLayout>
  );
};
